import './color-swatch-picker.scss'

import { defineComponent, PropType } from 'vue'

// Replaces vue3-swatches: that library binds its swatch-item clicks as a listener directly on a
// child component tag (relying on Vue's automatic root-attrs fallthrough), which never reaches the
// DOM under @vue/compat MODE 2 (kept on repo-wide for bootstrap-vue) — the same event-forwarding gap
// documented for font-awesome-icon/vue-konva elsewhere in this migration. b-dropdown is unaffected
// since it relays its own events internally (proven elsewhere in the app, e.g. synchro-modal).
export const ColorSwatchPicker = defineComponent({
    // Uses the still-repo-wide Vue 2 v-model shape (value/input) under @vue/compat's
    // COMPONENT_V_MODEL, matching how v-model is used on every other in-house component here.
    props: {
        value: { type: String, required: true },
        swatches: { type: Array as PropType<string[]>, required: true },
    },
    emits: ['input'],
    template: require('./color-swatch-picker.html'),
    methods: {
        selectColor(color: string) {
            this.$emit('input', color)
            ;(this.$refs.dropdown as any).hide()
        },
    },
})
